import React from 'react';
import { LabelledToggle } from '../../../../../components/LabelledToggle';
import { Control } from 'react-hook-form';

interface PropTypes {
  offerEnabled: boolean;
  disabled: boolean;
  formControl: Control<any>;
}

export function OfferToggleInput(props: PropTypes) {
  if (!props.offerEnabled) {
    return null;
  }

  return (
    <div className='d-flex mt-4 gap-2 flex-column'>
      <div className='d-flex align-items-center'>
        <label className='fs-5 fw-semibold me-2'>
          Do you want to send an Offer in this stage?
        </label>
        <LabelledToggle
          checkedLabel='Yes'
          disabled={props.disabled}
          formHookContext={{
            controllerName: 'offerEnabled',
            formControl: props.formControl,
          }}
          inputName='offerEnabled'
          labelPlacement='end'
          size='sm'
          uncheckedLabel='No'
          labelClassnames='text-dark-200'
        />
      </div>
      <span className='fs-6 text-muted'>
        Offer enablement will be available for only one stage per workflow.
      </span>
    </div>
  );
}
